export default __webpack_public_path__ + "static/media/credit.d92c21fc.svg";